import { render } from "./company_inbox.html?vue&type=template&id=124f2e50&external"
import script from "./company_inbox.js?vue&type=script&lang=js&external"
export * from "./company_inbox.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__